import React from 'react';
import Careers from '../components/Careers';

const CareersPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <Careers />
    </div>
  );
};

export default CareersPage;